var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOman(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5996 24.4502C19.227 24.4502 24.5996 19.0776 24.5996 12.4502C24.5996 5.82278 19.227 0.450195 12.5996 0.450195C5.97219 0.450195 0.599609 5.82278 0.599609 12.4502C0.599609 19.0776 5.97219 24.4502 12.5996 24.4502Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 12.4501C0.599609 16.9986 3.13039 20.9558 6.86047 22.991V1.90918C3.13039 3.9444 0.599609 7.90159 0.599609 12.4501Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8533 16.6239C24.3356 15.3239 24.5996 13.9179 24.5996 12.45C24.5996 10.9822 24.3356 9.57606 23.8533 8.27612H1.34605C0.863656 9.57606 0.599609 10.9822 0.599609 12.45C0.599609 13.9179 0.863656 15.3239 1.34605 16.6239L12.5996 17.6674L23.8533 16.6239Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5993 24.4501C17.7589 24.4501 22.1574 21.1936 23.8529 16.624H1.3457C3.04117 21.1936 7.43973 24.4501 12.5993 24.4501Z",
    fill: "#6DA544"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.599609 12.4501C0.599609 17.9945 4.35997 22.6597 9.46916 24.0367V0.863525C4.35997 2.24053 0.599609 6.90581 0.599609 12.4501Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9412 5.73079L6.83444 4.62402L6.09662 5.36193L5.35881 4.62402L4.25205 5.73079L4.98991 6.46865L4.25195 7.20655L5.35872 8.31332L6.09658 7.57541L6.83444 8.31332L7.9412 7.20655L7.20334 6.46865L7.9412 5.73079Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOman);
export default __webpack_public_path__ + "static/media/Oman.d40a7ff189962b040e5674821a34b515.svg";
export { ForwardRef as ReactComponent };